import { Injectable, Injector } from '@angular/core';
import {
    HttpInterceptor,
    HttpHandler,
    HttpEvent,
    HttpRequest,
    HttpHeaders
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { environment } from 'environments/environment';
import { ConfigService } from '@finder/core/config.service';
import { SsrService } from '@finder/shared/services/ssr/ssr.service';

@Injectable()
export class SiteIdInterceptor implements HttpInterceptor {

    constructor(
        private injector: Injector,
    ) { }

    /**
     * Add the site ID to every request
     */
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const configService = this.injector.get(ConfigService);
        const ssrService = this.injector.get(SsrService);

        // We don't need this for a prod environment, just local dev
        if (environment.production) {
            return next.handle(req);
        }

        if (ssrService.isSSR()) {
            return this.updateHeaders(req, next, configService.getSiteId());
        }

        // Get the cookie service
        const cookieService = this.injector.get(CookieService);
        if (!cookieService) {
            return next.handle(req);
        }

        // Check if we have the site ID cookie
        const siteIdCookie = cookieService.get('HTTP_X_DISNEY_INTERNAL_SITE');
        if (!siteIdCookie) {
            return next.handle(req);
        }

        return this.updateHeaders(req, next, siteIdCookie);
    }

    updateHeaders(req, next, siteId) {
        // Set the header with the value from the site ID cookie
        req = req.clone({
            setHeaders: {
                'X-Disney-Internal-Site': siteId,
            }
        });

        return next.handle(req);
    }
}
